import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { VSL } from './components/VSL';
import { Booking } from './components/Booking';
import { Services } from './components/Services';
import { Commitment } from './components/Commitment';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Reviews } from './components/Reviews';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-black font-sans selection:bg-amber-400/30 selection:text-white" data-id="element-0" data-mp="31agnwnhawdix">
      <Navbar data-id="element-1" data-mp="2wka0gqyiyz29" />
      <main data-id="element-2" data-mp="2wjqgz5t882m4">
        <Hero data-id="element-3" data-mp="2wiyuqllirh8i" />
        <VSL data-id="element-4" data-mp="2wifgpfyzpczr" />
        <Booking data-id="element-5" data-mp="2whx9xpepbgdl" />
        <Services data-id="element-6" data-mp="28ufp6dtutik4" />
        <Commitment data-id="element-7" data-mp="28tw5osok2m3z" />
        <Process data-id="element-8" data-mp="28te2fc3h77mk" />
        <Testimonials data-id="element-9" data-mp="28suvsrja05nu" />
        <Reviews data-id="element-10" data-mp="28s2xva27hvue" />
        <FAQ data-id="element-11" data-mp="23vkwmk634fmt" />
        <CTA data-id="element-12" data-mp="23vuoyeelqyvo" />
      </main>
      <Footer data-id="element-13" data-mp="23ujmchww7x65" />
    </div>;
}